import { Controparte } from "./controparte";
import { DocumentoAllegato } from './documento-allegato';

export class Patologia {
  id: string;
  patologia: string;
  lavoratore: Controparte;
  dataRiconoscimento: number;
  dataDiagnosi: number;
  dataDecesso: number;
  riconoscimentoMalattiaProfessionale: boolean = false;
  percentualeInvalidita: number;
  documenti: DocumentoAllegato[];
  note: string;
}
